import { c as _c } from "react/compiler-runtime";
// Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.
// svgs/light/camera-security.svg: path and width byte-identical (components/icons, Phase 5).
export default function LightCameraSecurityIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M384 32c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-59.8 0-200.4 0L64 384c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l320 0zM343.9 416l40.1 0c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l40.1 0L67.6 475.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3l272 0c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416zm-202.2 0l164.6 0 39.4 64-243.4 0 39.4-64zM224 304a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 208a128 128 0 1 0 256 0A128 128 0 1 0 96 208z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden="true" className={className} data-page-icon="light/camera-security" fill="currentColor" focusable="false" height="1em" overflow="visible" viewBox="0 0 448 512" width="0.875em">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}